import { SearchLg, X } from '@untitled-ui/icons-react';
import { ChangeEvent, ComponentPropsWithoutRef, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/utils/cn';

import Input from './Input';

interface InputSearchProps extends ComponentPropsWithoutRef<'div'> {
  isVisible?: boolean;
  onInputChanged?: (value: ChangeEvent<HTMLInputElement>) => void;
  onSearchIconClick?: () => void;
  onCancelButtonClick?: () => void;
}

export const InputSearch = forwardRef<HTMLDivElement, InputSearchProps>(
  ({ isVisible = true, onSearchIconClick, className, onInputChanged, onCancelButtonClick, ...rest }, ref) => {
    const { t } = useTranslation();

    return (
      <div
        className={cn(
          'relative md:flex justify-end hidden w-full',
          {
            hidden: isVisible,
          },
          className,
        )}
        ref={ref}
        {...rest}
      >
        <SearchLg
          className={cn('hidden mr-2 text-brand-brown hover:text-black animate-fade-right animate-duration-500 cursor-pointer', {
            flex: !isVisible,
          })}
          onClick={() => {
            onSearchIconClick?.();
          }}
        />
        <Input
          parentClassName={cn('z-1 mx-2 0')}
          placeholder={t('search', { ns: 'header' })}
          isVisible={isVisible}
          leftSide={<SearchLg className="text-brand-brown" />}
          rightSide={
            <X
              className="cursor-pointer text-brand-brown hover:text-black"
              onClick={() => {
                onCancelButtonClick?.();
              }}
            />
          }
          onChange={(value) => {
            onInputChanged?.(value);
          }}
        />
      </div>
    );
  },
);

InputSearch.displayName = 'InputSearch';
export default InputSearch;
